module.exports = __webpack_public_path__ + "static/sale-sticky-7c3427af05e6fd83e35baa8974e92b77.png";